export function TenantShowcase({ eyebrow, title }: { eyebrow: string; title: string }) {
  return (
    <>
      <p className="inline-flex max-w-full items-center gap-2 truncate rounded-full bg-white/10 px-3 py-1 text-xs font-medium text-white/85 ring-1 ring-white/20 backdrop-blur">
        <span className="size-1.5 shrink-0 rounded-full bg-emerald-400" />
        {eyebrow}
      </p>
      <h2 className="mt-4 text-4xl leading-[1.08] font-semibold tracking-tight text-balance">{title}</h2>
    </>
  )
}
